module.exports = __webpack_public_path__ + "static/media/logo_transparent.f00e4f88.png";